module.exports = __webpack_public_path__ + "img/manajemen_vendor.03474114.svg";